import React from 'react';
import './Team.css';

const teamRolesData = [
  {
    role: "AI Research Engineers",
    description: "LLM orchestration, semantic reasoning, agentic systems"
  },
  {
    role: "Platform & Full-Stack Engineers",
    description: "secure, scalable, cloud and on-prem deployments"
  },
  {
    role: "Product Engineers",
    description: "transforming domain needs into deployable AI systems via Ideonix"
  },
  {
    role: "Design & Experience",
    description: "human-centered interfaces for high-stakes environments"
  },
  {
    role: "Cognitva AI Agents",
    description: "proprietary digital workers embedded into every deployment"
  }
];

const isMobile = window.innerWidth <= 768;

const TeamMemberRole = ({ role, description }) => {
  return isMobile ? (
    <div className="team-member-role">
      <div className="role-title">{role}</div><br />{description}
    </div>
  )
    :
    (
      <div className="team-member-role">
        <h4 className="role-title">{role}</h4>
        <p className="role-description">{description}</p>
      </div>
    );
};


const sectionTitle = "- TECH TEAM";
const teamDescription = `Our core tech team brings deep experience in enterprise systems, 
AI/ML infrastructure, secure cloud-native architecture, and human-centered design - 
combining academic rigor with startup velocity.`;
const sectionSubTitle = <>Built by engineers. Designed for scale. Tuned for regulation.</>;
const Team = () => {
  return (
    <section className="team-section">
      <div className="team-top-content">
        {isMobile && (<>
          <div className="team-heading-right">
            <h3>{sectionTitle}</h3>
            <h2>{sectionSubTitle}</h2>
          </div><div className="team-description-left">
            <p>
              {teamDescription}
            </p>
          </div></>)}
        {!isMobile && (<>
          <div className="team-description-left">
            <p>
              {teamDescription}
            </p>
          </div>
          <div className="team-heading-right">
            <h3>{sectionTitle}</h3>
            <h2>{sectionSubTitle}</h2>
          </div>
        </>)}
      </div>
      <div className="team-roles-container">
        {teamRolesData.map((item, index) => (
          <TeamMemberRole key={index} role={item.role} description={item.description} />
        ))}
      </div>
      <div className="team-footer">
        <p>
          <img src="/images/user.svg" alt="Team Icon" className="team-icon" />
          Together, the team has shipped products used in Global Fortune 500 companies, public sector projects, and open-source AI communities
        </p>
      </div>
    </section>
  );
};

export default Team; 